<footer
  class="page-footer font-small mt-5 arabic-dir"
  style="background-color: rgba(0, 0, 0, 0.767)"
>
  <div style="background-color: #ec4646">
    <div class="container">
      <div class="row py-4 mx-0 d-flex align-items-center">
        <div class="col-md-6 col-lg-5 text-center text-md-left mb-4 mb-md-0">
          <h6 class="mb-0">{{ "BAZZAR.GET_CONNECTED" | translate }}</h6>
        </div>
        <div class="col-md-6 col-lg-7 text-center text-md-right">
          <a class="fb-ic mx-2" href="#" target="_blank">
            <i class="fab fa-facebook-f white-text"> </i>
          </a>

          <a class="ins-ic" href="#" target="_blank">
            <i class="fab fa-instagram white-text mx-3"> </i>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="container text-center text-md-left mt-5 px-0">
    <div class="row mt-3 mx-0 px-0">
      <div class="col-md-3 col-lg-4 col-xl-4 mx-auto mb-4">
        <h6 class="text-uppercase font-weight-bold">
          {{ "BAZZAR.TEMPLATE" | translate }}
        </h6>
        <hr
          class="primary accent-2 mb-4 mt-0 d-inline-block mx-auto"
          style="width: 60px"
        />
        <p>
          {{ "BAZZAR.FOOTER_SUBLINE" | translate }}
        </p>
      </div>

      <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
        <h6 class="text-uppercase font-weight-bold">
          {{ "BAZZAR.USEFUL_LINKS" | translate }}
        </h6>
        <hr
          class="primary accent-2 mb-4 mt-0 d-inline-block mx-auto"
          style="width: 60px"
        />

        <p>
          <a routerLink="/all-shops"> {{ "BAZZAR.ALL_SHOPS" | translate }}</a>
        </p>
        <p>
          <a routerLink="/join-us"> {{ "BAZZAR.JOIN_US" | translate }} </a>
        </p>
        <p>
          <a routerLink="/">{{ "BAZZAR.HOME" | translate }} </a>
        </p>
      </div>

      <div class="col-md-5 col-lg-4 col-xl-4 mx-auto mb-md-0 mb-4">
        <h6 class="text-uppercase font-weight-bold">
          {{ "BAZZAR.CONTACT" | translate }}
        </h6>
        <hr
          class="primary accent-2 mb-4 mt-0 d-inline-block mx-auto"
          style="width: 60px"
        />
        <p>
          <i class="fas fa-home mr-3"></i> {{ "BAZZAR.JORDAN" | translate }} ,
          {{ "BAZZAR.AMMAN" | translate }}
        </p>
        <p><i class="fas fa-envelope mr-3"></i> sondosmarashdeh360@gmail.com</p>
        <p><i class="fas fa-phone mr-3"></i> 0798022719</p>
      </div>
    </div>
  </div>

  <div
    class="footer-copyright text-center py-3"
    style="background-color: rgba(0, 0, 0, 0.555)"
  >
    {{ "BAZZAR.COPY_RIGHTS" | translate }}
    <a href="https://ssondoss.github.io/me/" target="_blank" class="anchor">{{
      "BAZZAR.SONDOS_MARASHEDH" | translate
    }}</a>

    <a> </a>
  </div>
</footer>
